
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30645',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30645",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55125",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8225",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11676",
  "I18n": "static-7.1650",
  "quartz": "static-1.7299",
  "quartz-config": "static-1.1077",
  "quartz-core": "static-1.6518",
  "react-dlb": "static-1.83",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "reselect": "static-3.8",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.851",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55112",
  "feedback-utils": "static-1.55116",
  "forms-embed-utils-lib": "static-1.4667",
  "forms-utils-lib": "static-1.12945",
  "foundations-assets": "static-1.5077",
  "foundations-components": "static-1.8310",
  "foundations-theming": "static-1.4643",
  "hub-http": "static-1.6419",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11983",
  "icons": "static-2.668",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.4059",
  "raven": "static-3.5925",
  "react": "static-7.189",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1-aeastham-base-reporter-resolved-tracking.4",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5482",
  "react-virtualized": "static-2.102",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.491",
  "tinymce-plugins": "static-1.58016",
  "transmute": "static-2.85",
  "ui-images": "static-2.1212",
  "UIComponents": "static-3.8622",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3540",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3576",
  "quartz-webpack": "static-1.3523",
  "foundations-theming-specialty": "static-1.2359",
  "property-description-translator": "static-1.4041",
  "HeadJS": "static-2.781",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3336",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4525",
  "jasmine-runner": "static-1.6656",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.858",
  "hubspotter-http": "static-1.4792",
  "mobile-manifest-mixins": "static-1.555",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.974",
  "quartz-head": "static-1.964",
  "quartz-i18n": "static-1.974",
  "quartz-routing": "static-1.729",
  "quartz-test": "static-1.974",
  "quartz-tracking": "static-1.678",
  "trellis-components": "static-1.2354",
  "ui-fonts": "static-1.938",
  "usage-tracker-container": "static-1-session-replay-endpoint-migration.5",
  "usage-tracker-core": "static-1-session-replay-endpoint-migration.5",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.160",
  "conversations-skeleton-state": "static-1.7449",
  "reference-resolvers": "static-1.8378",
  "sanitize-text": "static-1.8348",
  "PatternValidationJS": "static-1-add-latest-to-version-tag.2",
  "ReduxMessenger": "static-2.10567",
  "sanitize": "static-1.4679",
  "outpost": "static-1.4368",
  "rpc-client-utils": "static-1.4860",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4579",
  "floating-ui": "static-1.60",
  "hs-story-utils": "static-1.9628",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.50",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2335",
  "bend-plugin-foundations-theming": "static-1.3126",
  "foundations-theming-base": "static-1.3628",
  "stylex": "static-1.37",
  "hs-locale-management": "static-1.222",
  "csstype": "static-1.50",
  "web-vitals": "static-1.9",
  "ai-components-ui-library": "static-1.9464",
  "atom": "static-1.5278",
  "codemirror": "static-5.98",
  "content-assistance-lib": "static-1.8060",
  "ContentUtils": "static-1.68947",
  "data-token-picker": "static-1.16752",
  "file-manager-components": "static-1.24216",
  "FileManagerCore": "static-1.39715",
  "FileManagerLib": "static-1.39856",
  "frontend-preferences-client": "static-1.8128",
  "hub-http-contrib": "static-1.3243",
  "interframe": "static-3.4957",
  "layout-dnd-components": "static-1.12823",
  "layout-dnd-utils": "static-1.11798",
  "property-translator": "static-1.5597",
  "react-codemirror": "static-1.10842",
  "react-colorpicker": "static-2.10411",
  "reference-resolvers-lite": "static-1.8299",
  "rich-text-lib": "static-1.20172",
  "tinymce-data": "static-1.40987",
  "tinymce-themes": "static-1.56872",
  "ui-addon-emoji-picker": "static-1.10087",
  "ui-addon-sales-email": "static-1.5414",
  "ui-brand-identity-lib": "static-1.16020",
  "bender-build-tools": "static-1.3322",
  "hub-http-shared-msw-handlers": "static-1.10445",
  "hubspotter-http-shared-msw-handlers": "static-1.10443",
  "usage-tracker-session-replay": "static-1-session-replay-endpoint-migration.5",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1153",
  "tanstack-virtual": "static-1.33",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.270",
  "chirp-fetch": "static-1.2089",
  "chatspot-core": "static-1.22340",
  "copilot-toolkit": "static-1.11650",
  "customer-data-objects-ui-components": "static-1.13234",
  "data-fetching-client": "static-1.9859",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4960",
  "ui-addon-video-player": "static-1.8908",
  "ui-coaching-tips": "static-1.29117",
  "usage-tracker": "static-1-session-replay-endpoint-migration.5",
  "cms-field-types": "static-1.5017",
  "content-icons-ui": "static-1.2287",
  "integrations-lib": "static-1.16789",
  "customer-data-objects": "static-1.7882",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1428",
  "apollo-link-hub-http": "static-2.4855",
  "apollo-stack-hubspot": "static-3.89",
  "graphql": "static-1.85",
  "immer": "static-1.33",
  "immerable": "static-1.4349",
  "ui-addon-iframeable": "static-1.9277",
  "video-components-external": "static-1.11924",
  "video-data-lib": "static-1.35582",
  "audio-components": "static-1.6210",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29662",
  "FileManagerImages": "static-1.37367",
  "foundations-components-legacy": "static-1.1335",
  "html-to-image": "static-1.57",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "salesImages": "static-1.529",
  "ui-universal-auth": "static-1.9220",
  "urlinator": "static-1.4734",
  "video-components": "static-1.13926",
  "video-embed": "static-1.36416",
  "ts-schema": "static-1.4221",
  "ContentData": "static-1.69022",
  "layout-data-lib": "static-1.10123",
  "react-dnd-compat": "static-1.4816",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1746",
  "external-options-client-types": "static-1.4267",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7096",
  "hs-promise-utils": "static-1.5795",
  "inbound-db-properties-service-client": "static-1.3986",
  "NamespacedHubStyle": "static-2.9191",
  "growth-onboarding-confetti": "static-1.3263",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11348",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5694",
  "magpie-types": "static-1.5154",
  "simple-logging-lib": "static-1.3251",
  "avatar-components": "static-1.2699",
  "customer-data-ui-utilities": "static-1.10027",
  "growth-onboarding-feedback-components": "static-1.6783",
  "flux-actions": "static-1.355",
  "hubspot-apollo-client": "static-1.5079",
  "integrations-error-boundary-lib": "static-1.14204",
  "integrations-tracking-lib": "static-1.5809",
  "laboratory-lib": "static-3.7353",
  "native-integrations-shared-strings": "static-1.7980",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10463",
  "unified-auth": "static-1.734",
  "breeze-engine-core": "static-1.706",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "navigation-messaging": "static-1.7924",
  "content-media-composition-data-lib": "static-1.12962",
  "content-media-compositions": "static-2.16969",
  "idb-keyval": "static-1.47",
  "media-bridge-lib": "static-1.19270",
  "unified-auth-core-lib": "static-1.1016",
  "social-insights-client-types": "static-1.22594",
  "advanced-menus-core": "static-1.15450",
  "advanced-menus-lib": "static-1.12343",
  "ExportDialog": "static-6.10581",
  "ui-memberships-settings-lib": "static-1.34607",
  "conditional-properties-service-client": "static-1.3938",
  "crm-pipelines-api-client-types": "static-1.4279",
  "fdsr-migration-layer": "static-1.215",
  "framework-builder-read-service-client": "static-1.4147",
  "framework-data-schema-quick-fetch": "static-1.7001",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3832",
  "persist-promise": "static-1.3903",
  "foundations-components-test-utils": "static-1.5793",
  "reactive-lib": "static-1.924",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.538",
  "universal-page-editor-lib": "static-1.3213",
  "adobe-sign-auth-lib": "static-1.251",
  "ads-unified-auth-lib": "static-1.772",
  "google-sheets-integration-lib": "static-1.828",
  "microsoft-drive-integration-lib": "static-1.935",
  "surveymonkey-integration-lib": "static-1.273",
  "slack-ui-library": "static-1.10600",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3934",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15449",
  "simple-menus-lib": "static-1.16966",
  "crm-record-cards-service-types": "static-1.3725",
  "location-customization-utils-lib": "static-1.9870",
  "react-flip-move": "static-1.74"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30645",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55125",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8225",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11676",
  "I18n": "/I18n/static-7.1650",
  "quartz": "/quartz/static-1.7299",
  "quartz-config": "/quartz-config/static-1.1077",
  "quartz-core": "/quartz-core/static-1.6518",
  "react-dlb": "/react-dlb/static-1.83",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reselect": "/reselect/static-3.8",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.851",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55112",
  "feedback-utils": "/feedback-utils/static-1.55116",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4667",
  "forms-utils-lib": "/forms-utils-lib/static-1.12945",
  "foundations-assets": "/foundations-assets/static-1.5077",
  "foundations-components": "/foundations-components/static-1.8310",
  "foundations-theming": "/foundations-theming/static-1.4643",
  "hub-http": "/hub-http/static-1.6419",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11983",
  "icons": "/icons/static-2.668",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.4059",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.189",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1-aeastham-base-reporter-resolved-tracking.4",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5482",
  "react-virtualized": "/react-virtualized/static-2.102",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "tinymce-plugins": "/tinymce-plugins/static-1.58016",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1212",
  "UIComponents": "/UIComponents/static-3.8622",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3540",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3576",
  "quartz-webpack": "/quartz-webpack/static-1.3523",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2359",
  "property-description-translator": "/property-description-translator/static-1.4041",
  "HeadJS": "/HeadJS/static-2.781",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3336",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4525",
  "jasmine-runner": "/jasmine-runner/static-1.6656",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.858",
  "hubspotter-http": "/hubspotter-http/static-1.4792",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.555",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.974",
  "quartz-head": "/quartz-head/static-1.964",
  "quartz-i18n": "/quartz-i18n/static-1.974",
  "quartz-routing": "/quartz-routing/static-1.729",
  "quartz-test": "/quartz-test/static-1.974",
  "quartz-tracking": "/quartz-tracking/static-1.678",
  "trellis-components": "/trellis-components/static-1.2354",
  "ui-fonts": "/ui-fonts/static-1.938",
  "usage-tracker-container": "/usage-tracker-container/static-1-session-replay-endpoint-migration.5",
  "usage-tracker-core": "/usage-tracker-core/static-1-session-replay-endpoint-migration.5",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.160",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7449",
  "reference-resolvers": "/reference-resolvers/static-1.8378",
  "sanitize-text": "/sanitize-text/static-1.8348",
  "PatternValidationJS": "/PatternValidationJS/static-1-add-latest-to-version-tag.2",
  "ReduxMessenger": "/ReduxMessenger/static-2.10567",
  "sanitize": "/sanitize/static-1.4679",
  "outpost": "/outpost/static-1.4368",
  "rpc-client-utils": "/rpc-client-utils/static-1.4860",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4579",
  "floating-ui": "/floating-ui/static-1.60",
  "hs-story-utils": "/hs-story-utils/static-1.9628",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.50",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2335",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3126",
  "foundations-theming-base": "/foundations-theming-base/static-1.3628",
  "stylex": "/stylex/static-1.37",
  "hs-locale-management": "/hs-locale-management/static-1.222",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.9",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9464",
  "atom": "/atom/static-1.5278",
  "codemirror": "/codemirror/static-5.98",
  "content-assistance-lib": "/content-assistance-lib/static-1.8060",
  "ContentUtils": "/ContentUtils/static-1.68947",
  "data-token-picker": "/data-token-picker/static-1.16752",
  "file-manager-components": "/file-manager-components/static-1.24216",
  "FileManagerCore": "/FileManagerCore/static-1.39715",
  "FileManagerLib": "/FileManagerLib/static-1.39856",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8128",
  "hub-http-contrib": "/hub-http-contrib/static-1.3243",
  "interframe": "/interframe/static-3.4957",
  "layout-dnd-components": "/layout-dnd-components/static-1.12823",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11798",
  "property-translator": "/property-translator/static-1.5597",
  "react-codemirror": "/react-codemirror/static-1.10842",
  "react-colorpicker": "/react-colorpicker/static-2.10411",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8299",
  "rich-text-lib": "/rich-text-lib/static-1.20172",
  "tinymce-data": "/tinymce-data/static-1.40987",
  "tinymce-themes": "/tinymce-themes/static-1.56872",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10087",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5414",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16020",
  "bender-build-tools": "/bender-build-tools/static-1.3322",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10445",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10443",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-session-replay-endpoint-migration.5",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1153",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.270",
  "chirp-fetch": "/chirp-fetch/static-1.2089",
  "chatspot-core": "/chatspot-core/static-1.22340",
  "copilot-toolkit": "/copilot-toolkit/static-1.11650",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13234",
  "data-fetching-client": "/data-fetching-client/static-1.9859",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4960",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8908",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29117",
  "usage-tracker": "/usage-tracker/static-1-session-replay-endpoint-migration.5",
  "cms-field-types": "/cms-field-types/static-1.5017",
  "content-icons-ui": "/content-icons-ui/static-1.2287",
  "integrations-lib": "/integrations-lib/static-1.16789",
  "customer-data-objects": "/customer-data-objects/static-1.7882",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1428",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4855",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "graphql": "/graphql/static-1.85",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4349",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9277",
  "video-components-external": "/video-components-external/static-1.11924",
  "video-data-lib": "/video-data-lib/static-1.35582",
  "audio-components": "/audio-components/static-1.6210",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29662",
  "FileManagerImages": "/FileManagerImages/static-1.37367",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1335",
  "html-to-image": "/html-to-image/static-1.57",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "salesImages": "/salesImages/static-1.529",
  "ui-universal-auth": "/ui-universal-auth/static-1.9220",
  "urlinator": "/urlinator/static-1.4734",
  "video-components": "/video-components/static-1.13926",
  "video-embed": "/video-embed/static-1.36416",
  "ts-schema": "/ts-schema/static-1.4221",
  "ContentData": "/ContentData/static-1.69022",
  "layout-data-lib": "/layout-data-lib/static-1.10123",
  "react-dnd-compat": "/react-dnd-compat/static-1.4816",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1746",
  "external-options-client-types": "/external-options-client-types/static-1.4267",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7096",
  "hs-promise-utils": "/hs-promise-utils/static-1.5795",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3986",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9191",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3263",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11348",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5694",
  "magpie-types": "/magpie-types/static-1.5154",
  "simple-logging-lib": "/simple-logging-lib/static-1.3251",
  "avatar-components": "/avatar-components/static-1.2699",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10027",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6783",
  "flux-actions": "/flux-actions/static-1.355",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5079",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14204",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5809",
  "laboratory-lib": "/laboratory-lib/static-3.7353",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7980",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10463",
  "unified-auth": "/unified-auth/static-1.734",
  "breeze-engine-core": "/breeze-engine-core/static-1.706",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "navigation-messaging": "/navigation-messaging/static-1.7924",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12962",
  "content-media-compositions": "/content-media-compositions/static-2.16969",
  "idb-keyval": "/idb-keyval/static-1.47",
  "media-bridge-lib": "/media-bridge-lib/static-1.19270",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1016",
  "social-insights-client-types": "/social-insights-client-types/static-1.22594",
  "advanced-menus-core": "/advanced-menus-core/static-1.15450",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12343",
  "ExportDialog": "/ExportDialog/static-6.10581",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34607",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3938",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4279",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.215",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4147",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7001",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3832",
  "persist-promise": "/persist-promise/static-1.3903",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5793",
  "reactive-lib": "/reactive-lib/static-1.924",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.538",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3213",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.251",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.772",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.828",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.935",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.273",
  "slack-ui-library": "/slack-ui-library/static-1.10600",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3934",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15449",
  "simple-menus-lib": "/simple-menus-lib/static-1.16966",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3725",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9870",
  "react-flip-move": "/react-flip-move/static-1.74"
}
};
